export const BORN_NUMBER_FIELD = 'bornNumberField'
export const SCOOTER = 'scooter'
export const ACCIDENT_INSURANCE = 'accidentInsurance'

export const ALL_AB_TESTS = [
  BORN_NUMBER_FIELD,
  SCOOTER,
  ACCIDENT_INSURANCE,
] as const

export type AbTest = typeof ALL_AB_TESTS[number]
